import { useEffect, useState } from 'react';

import { FilePreview } from './components';
import { TemplateList } from './ui';
import { UploadButton } from '../shared';

import { useAppDispatch } from '@shared/model';
import { setTemplates, useAddTemplateMutation, useGetTemplatesQuery } from '@entities/template';
import { previewContainerStyle, wrapperStyle } from './Templates.tailwind';
import { Loader } from '@shared/ui';

const Templates = () => {
  const dispatch = useAppDispatch();
  const { data: templates, isLoading } = useGetTemplatesQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });
  const [addTemplateAsync] = useAddTemplateMutation();

  const [template, setTemplate] = useState<File | null>();

  const handleSave = async (templateNumber: number) => {
    if (template && templateNumber) {
      const formData = new FormData();

      formData.append('file', template);
      formData.append('templateNumber', templateNumber.toString());

      setTemplate(null);
      await addTemplateAsync(formData);
    }
  };

  const handleCancel = () => setTemplate(null);

  useEffect(() => {
    if (templates) {
      dispatch(setTemplates(templates));
    }
  }, [templates, dispatch]);

  return (
    <div className={wrapperStyle}>
      <div className={previewContainerStyle}>
        <h2 className="text-2xl">Choose a Template (.docx)</h2>

        {template ? <FilePreview onSave={handleSave} onCancel={handleCancel} filename={template.name} /> : null}

        <UploadButton type="primary" text="Upload a Template" onUpload={setTemplate} fileTypes={['.docx']} />
      </div>

      {isLoading ? <Loader bgColor="bg-waterspout" /> : <TemplateList />}
    </div>
  );
};

export default Templates;
